import BrandEquity from './BrandEquity';
import Default from './Default';

export default {
  BrandEquity,
  Default,
};
